import React from 'react';
import styles from './style.module.scss';

export default props => (
  <div className={styles['body']}>
    <div className={styles['content']}>{props.children}</div>
  </div>
);
